import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  InputBase,
  Modal,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Switch,
  CircularProgress,
} from "@mui/material";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CustomAxios from "../../utils/CustomAxios";
import { useGetWeeklySlots } from "../globalFunctions";
import { useSelector } from "react-redux";

export function WeeklyDeliverySlots() {
  const toast = useRef(null);
  const user_id = localStorage.getItem('user_id')
  const weeklySlots = useSelector((state) => state.delivery.weeklySlots || []);
console.log("weeklySlots", weeklySlots)
  const [weeklySlotsLoading, setWeeklySlotsLoading] = useState(false);
  const [weeklySlotModalOpen, setWeeklySlotModalOpen] = useState(false);
  const [weeklySlotEditId, setWeeklySlotEditId] = useState(null);
  const [weeklySlotForm, setWeeklySlotForm] = useState({
    day_of_week: "",
    start_time: "",
    end_time: "",
    max_capacity: "",
    cutoff_minutes_before: 0,
    is_active: true,
    is_holiday: false,
    future_booking_allowed: true,
    hub: "",
    slot_type: "delivery",
  });
  const [weeklySlotErrors, setWeeklySlotErrors] = useState({});
  const [slotTypeFilter, setSlotTypeFilter] = useState("delivery");
  const [weekdayFilter, setWeekdayFilter] = useState(0);
  const fetchWeeklySlots = useGetWeeklySlots()
  const user_role = localStorage.getItem("role");
  const canManageDelivery = ["super_admin", "admin", "supervisor","merchant"].includes(
    user_role
  );
  const hubId = localStorage.getItem("selected_hub");

  const weeklySlotDays = [
    { name: "Monday", value: 0 },
    { name: "Tuesday", value: 1 },
    { name: "Wednesday", value: 2 },
    { name: "Thursday", value: 3 },
    { name: "Friday", value: 4 },
    { name: "Saturday", value: 5 },
    { name: "Sunday", value: 6 },
  ];

  const weeklySlotDayNames = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const slotTypeOptions = [
    { name: "Delivery", value: "delivery" },
    { name: "Self Pickup", value: "pickup" },
  ];

  const slotTypeFilterOptions = [
    { name: "All", value: "all" },
    ...slotTypeOptions,
  ];

  const weekdayFilterOptions = [
    { name: "All days", value: "all" },
    ...weeklySlotDays,
  ];

  const filteredSlots = weeklySlotsLoading
    ? []
    : (weeklySlots || []).filter((slot) => {
        const matchType = slotTypeFilter === "all" || slot.slot_type === slotTypeFilter;
        const matchDay = weekdayFilter === "all" || slot.day_of_week === weekdayFilter;
        return matchType && matchDay;
      });

  const timeToMinutes = (t) => {
    if (!t) return 0;
    const [h, m] = t.split(":").map(Number);
    if (Number.isNaN(h) || Number.isNaN(m)) return 0;
    return h * 60 + m;
  };

  const validateWeeklySlotForm = () => {
    const errors = {};

    if (
      weeklySlotForm.day_of_week === "" ||
      weeklySlotForm.day_of_week === null ||
      weeklySlotForm.day_of_week === undefined
    ) {
      errors.day_of_week = "Day is required";
    }
    if (!weeklySlotForm.start_time) {
      errors.start_time = "Start time is required";
    }
    if (!weeklySlotForm.end_time) {
      errors.end_time = "End time is required";
    }
    if (weeklySlotForm.start_time && weeklySlotForm.end_time) {
      const start = timeToMinutes(weeklySlotForm.start_time);
      const end = timeToMinutes(weeklySlotForm.end_time);
      if (end <= start) {
        errors.end_time = "End time must be after start time";
      }
    }

    const maxCap = Number(weeklySlotForm.max_capacity);
    const cutoff = Number(weeklySlotForm.cutoff_minutes_before || 0);

    if (!maxCap || maxCap <= 0) {
      errors.max_capacity = "Max capacity must be greater than 0";
    }
    if (cutoff < 0) {
      errors.cutoff_minutes_before = "Cutoff minutes must be 0 or more";
    }

    setWeeklySlotErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const resetWeeklySlotForm = () => {
    setWeeklySlotForm({
      day_of_week: "",
      start_time: "",
      end_time: "",
      max_capacity: "",
      cutoff_minutes_before: 0,
      is_active: true,
      is_holiday: false,
      future_booking_allowed: true,
      slot_type: "delivery",
    });
    setWeeklySlotErrors({});
    setWeeklySlotEditId(null);
  };



  const handleOpenWeeklySlotModal = (slot = null) => {
    if (slot) {
      setWeeklySlotEditId(slot.id);
      setWeeklySlotForm({
        day_of_week: slot.day_of_week,
        start_time: slot.start_time ? slot.start_time.slice(0, 5) : "",
        end_time: slot.end_time ? slot.end_time.slice(0, 5) : "",
        max_capacity: slot.max_capacity ?? "",
        cutoff_minutes_before: slot.cutoff_minutes_before ?? 0,
        is_active: !!slot.is_active,
        is_holiday: !!slot.is_holiday,
        future_booking_allowed: !!slot.future_booking_allowed,
        slot_type: slot.slot_type ?? "delivery",
      });
      setWeeklySlotErrors({});
    } else {
      resetWeeklySlotForm();
    }
    setWeeklySlotModalOpen(true);
  };

  const handleCloseWeeklySlotModal = () => {
    setWeeklySlotModalOpen(false);
    resetWeeklySlotForm();
  };

  const handleWeeklySlotInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "day_of_week") {
      newValue = value === "" ? "" : Number(value);
    } else if (
      ["max_capacity", "cutoff_minutes_before"].includes(name)
    ) {
      newValue = value === "" ? "" : Number(value);
    }

    setWeeklySlotForm((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleWeeklySlotToggleChange = (name) => (event) => {
    const checked = event.target.checked;
    console.log("checked", checked)
    setWeeklySlotForm((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const formatTimeForApi = (value) => {
    if (!value) return null;
    if (value.length === 5) return `${value}:00`;
    return value;
  };

  const handleSaveWeeklySlot = async () => {
    if (!validateWeeklySlotForm()) {
      return;
    }

    const payload = {
      day_of_week: weeklySlotForm.day_of_week,
      start_time: formatTimeForApi(weeklySlotForm.start_time),
      end_time: formatTimeForApi(weeklySlotForm.end_time),
      max_capacity: Number(weeklySlotForm.max_capacity),
      cutoff_minutes_before: Number(weeklySlotForm.cutoff_minutes_before || 0),
      is_active: !!weeklySlotForm.is_active,
      is_holiday: !!weeklySlotForm.is_holiday,
      hub: hubId,
      future_booking_allowed: !!weeklySlotForm.future_booking_allowed,
      slot_type: weeklySlotForm.slot_type,
      created_by: weeklySlotEditId?'':user_id,
      updated_by: weeklySlotEditId ? user_id :'' 
    };

    try {
      setWeeklySlotsLoading(true);
      if (weeklySlotEditId) {
        await CustomAxios.put(`delivery_slots/${weeklySlotEditId}/`, payload);
        toast.current?.show({
          severity: "success",
          summary: "Updated",
          detail: "Delivery slot updated successfully",
          life: 3000,
        });
      } else {
        await CustomAxios.post("delivery_slots/", payload);
        toast.current?.show({
          severity: "success",
          summary: "Created",
          detail: "Delivery slot created successfully",
          life: 3000,
        });
      }
      handleCloseWeeklySlotModal();
      fetchWeeklySlots();
    } catch (error) {
      console.error("Error saving weekly slot:", error);
      
      // Extract error message from response
      let errorMessage = "Failed to save delivery slot";
      if (error?.response?.data) {
        const errorData = error.response.data;
        if (errorData.details) {
          // Handle validation error with details
          if (typeof errorData.details === 'string') {
            errorMessage = errorData.details;
          } else if (typeof errorData.details === 'object') {
            // If details is an object, extract the first error message
            const firstError = Object.values(errorData.details)[0];
            errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;
          }
        } else if (errorData.error) {
          errorMessage = typeof errorData.error === 'string' ? errorData.error : JSON.stringify(errorData.error);
        } else if (errorData.message) {
          errorMessage = errorData.message;
        } else if (typeof errorData === 'string') {
          errorMessage = errorData;
        }
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
        life: 5000,
      });
    } finally {
      setWeeklySlotsLoading(false);
    }
  };

  const handleEditWeeklySlot = (slot) => {
    handleOpenWeeklySlotModal(slot);
  };

  const handleDeleteWeeklySlot = async (id) => {
    const confirmed = window.confirm("Do you want to delete this delivery slot?");
    if (!confirmed) return;

    try {
      setWeeklySlotsLoading(true);
      await CustomAxios.delete(`delivery_slots/${id}/`);
      toast.current?.show({
        severity: "success",
        summary: "Deleted",
        detail: "Delivery slot deleted successfully",
        life: 3000,
      });
      fetchWeeklySlots();
    } catch (error) {
      console.error("Error deleting weekly slot:", error);
      
      // Extract error message from response
      let errorMessage = "Failed to delete delivery slot";
      if (error?.response?.data) {
        const errorData = error.response.data;
        if (errorData.details) {
          errorMessage = typeof errorData.details === 'string' ? errorData.details : JSON.stringify(errorData.details);
        } else if (errorData.error) {
          errorMessage = typeof errorData.error === 'string' ? errorData.error : JSON.stringify(errorData.error);
        } else if (errorData.message) {
          errorMessage = errorData.message;
        } else if (typeof errorData === 'string') {
          errorMessage = errorData;
        }
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
        life: 5000,
      });
    } finally {
      setWeeklySlotsLoading(false);
    }
  };

  useEffect(() => {
    fetchWeeklySlots();
  }, []);
console.log("weeklySlotForm", weeklySlots[0]?.future_booking_allowed)
  if (!canManageDelivery) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          padding: "20px",
        }}
      >
        <Typography variant="h6" color="error">
          Access Denied
        </Typography>
        <Typography>
          You don't have permission to manage weekly delivery slots.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        width: "100%",
        padding: "30px",
      }}
    >
      <Toast ref={toast} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Typography
          sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}
        >
          Weekly Delivery Slots
        </Typography>
        <Typography
          sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}
        >
          Configure recurring weekly delivery time slots and capacity.
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          mt: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Box sx={{
              minWidth: { xs: "100%", sm: "180px" },
              maxWidth: { xs: "100%", sm: "200px" },
              "& .p-dropdown": {
                height: { xs: "36px", md: "32px" },
                fontSize: { xs: "12px", sm: "14px" },
                width: "100%",
              },
              "& .p-dropdown-label": {
                textAlign: "center",
                padding: { xs: "5px 12px", sm: "6px 14px" },
              },
            }}>
              <Dropdown
                value={slotTypeFilter}
                options={slotTypeFilterOptions}
                onChange={(e) => setSlotTypeFilter(e.value)}
                optionLabel="name"
                optionValue="value"
                placeholder="All"
                style={{ zIndex: "1000" }}
                className="w-full"
                appendTo="self"
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Box sx={{
              minWidth: { xs: "100%", sm: "180px" },
              maxWidth: { xs: "100%", sm: "200px" },
              "& .p-dropdown": {
                height: { xs: "36px", md: "32px" },
                fontSize: { xs: "12px", sm: "14px" },
                width: "100%",
              },
              "& .p-dropdown-label": {
                textAlign: "center",
                padding: { xs: "5px 12px", sm: "6px 14px" },
              },
            }}>
              <Dropdown
                value={weekdayFilter}
                options={weekdayFilterOptions}
                onChange={(e) => setWeekdayFilter(e.value)}
                optionLabel="name"
                optionValue="value"
                placeholder="All days"
                style={{ zIndex: "1000" }}
                className="w-full"
                appendTo="self"
              />
            </Box>
          </Box>
        </Box>
        <Button
          variant="contained"
          onClick={() => handleOpenWeeklySlotModal()}
          sx={{ textTransform: "none" }}
        >
          Add Slot
        </Button>
      </Box>
      <Box sx={{ mt: 2 }}>
        <TableContainer sx={{ backgroundColor: "white" }}>
          <Table stickyHeader aria-label="weekly slots table">
            <TableHead style={{ backgroundColor: "background.upload" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "600", textAlign: "center" }}>
                  S No
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Slot Type
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Day
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Time
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Max Capacity
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Booked
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Remaining
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Cutoff (mins)
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Active
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Holiday
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Future Booking Allowed
                </TableCell>
                <TableCell sx={{ fontWeight: "600", textAlign: "left" }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[...filteredSlots]
                .sort((a, b) => {
                  if (a.day_of_week !== b.day_of_week) {
                    return a.day_of_week - b.day_of_week;
                  }
                  if (!a.start_time || !b.start_time) return 0;
                  return a.start_time.localeCompare(b.start_time);
                })
                .map((slot, index) => {
                const remaining =
                  Math.max(
                    Number(slot.max_capacity || 0) -
                      Number(slot.booked_capacity || 0),
                    0
                  ) || 0;
                return (
                  <TableRow key={slot.id || index} sx={{ background: "white" }}>
                    <TableCell sx={{ textAlign: "center" }}>
                      {index + 1}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {slot.slot_type === 'pickup' ? 'Self Pickup' : 'Delivery'}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {weeklySlotDayNames[slot.day_of_week] ?? "-"}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {slot.start_time?.slice(0, 5)} -{" "}
                      {slot.end_time?.slice(0, 5)}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {slot.max_capacity}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {slot.booked_capacity}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {remaining}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {slot.cutoff_minutes_before}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {slot.is_active ? "Yes" : "No"}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {slot.is_holiday ? "Yes" : "No"}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      {slot.future_booking_allowed ? "Yes" : "No"}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left" }}>
                      <Tooltip title="Edit" arrow>
                        <IconButton onClick={() => handleEditWeeklySlot(slot)}>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete" arrow>
                        <IconButton
                          onClick={() => handleDeleteWeeklySlot(slot.id)}
                        >
                          <DeleteOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
              {!weeklySlotsLoading && filteredSlots.length === 0 && (
                <TableRow>
                  <TableCell colSpan={11} sx={{ textAlign: "center" }}>
                    No delivery slots found.
                  </TableCell>
                </TableRow>
              )}
              {weeklySlotsLoading && (
                <TableRow>
                  <TableCell colSpan={11} sx={{ textAlign: "center" }}>
                    Loading...
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Modal
        open={weeklySlotModalOpen}
        onClose={handleCloseWeeklySlotModal}
        aria-labelledby="weekly-slot-modal-title"
        aria-describedby="weekly-slot-modal-description"
        sx={{ zIndex: 1000 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            maxWidth: "520px",
            backgroundColor: "white",
          }}
        >
          <Box
            sx={{
              height: "46px",
              padding: "12px 24px",
              backgroundColor: "#EEEEEE",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}
            >
              {weeklySlotEditId
                ? "Edit Weekly Delivery Slot"
                : "Add Weekly Delivery Slot"}
            </Typography>
          </Box>
          <Box
            sx={{
              padding: "24px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}
              >
                Slot Type<span style={{ color: "red", marginLeft: 4 }}>*</span>
              </Typography>
              <Dropdown
                value={weeklySlotForm.slot_type}
                options={slotTypeOptions}
                name="slot_type"
                optionLabel="name"
                optionValue="value"
                placeholder="Select slot type"
                className="w-full md:w-20rem"
                appendTo="self"
                onChange={(e) =>
                  setWeeklySlotForm((prev) => ({
                    ...prev,
                    slot_type: e.value,
                  }))
                }
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography
                sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}
              >
                Day of Week<span style={{ color: "red", marginLeft: 4 }}>*</span>
              </Typography>
              <Dropdown
                value={weeklySlotForm.day_of_week}
                options={weeklySlotDays}
                name="day_of_week"
                optionLabel="name"
                optionValue="value"
                placeholder="Select day"
                className="w-full md:w-20rem"
                appendTo="self"
                onChange={(e) =>
                  setWeeklySlotForm((prev) => ({
                    ...prev,
                    day_of_week: e.value,
                  }))
                }
              />
              {weeklySlotErrors.day_of_week && (
                <Typography
                  sx={{ color: "red", fontSize: "12px", lineHeight: "18px" }}
                >
                  {weeklySlotErrors.day_of_week}
                </Typography>
              )}
            </Box>
            <Box sx={{ display: "flex", gap: "16px" }}>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "22px",
                  }}
                >
                  Start Time<span style={{ color: "red", marginLeft: 4 }}>*</span>
                </Typography>
                <InputBase
                  type="time"
                  name="start_time"
                  value={weeklySlotForm.start_time}
                  onChange={handleWeeklySlotInputChange}
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    height: "32px",
                    borderRadius: "2px",
                    border: "1px solid",
                    borderColor: "secondary.border",
                    padding: "5px 12px",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    color: "black",
                  }}
                />
                {weeklySlotErrors.start_time && (
                  <Typography
                    sx={{ color: "red", fontSize: "12px", lineHeight: "18px" }}
                  >
                    {weeklySlotErrors.start_time}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "22px",
                  }}
                >
                  End Time<span style={{ color: "red", marginLeft: 4 }}>*</span>
                </Typography>
                <InputBase
                  type="time"
                  name="end_time"
                  value={weeklySlotForm.end_time}
                  onChange={handleWeeklySlotInputChange}
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    height: "32px",
                    borderRadius: "2px",
                    border: "1px solid",
                    borderColor: "secondary.border",
                    padding: "5px 12px",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    color: "black",
                  }}
                />
                {weeklySlotErrors.end_time && (
                  <Typography
                    sx={{ color: "red", fontSize: "12px", lineHeight: "18px" }}
                  >
                    {weeklySlotErrors.end_time}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box sx={{ display: "flex", gap: "16px" }}>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "22px",
                  }}
                >
                  Max Capacity<span style={{ color: "red", marginLeft: 4 }}>*</span>
                </Typography>
                <InputBase
                  type="number"
                  name="max_capacity"
                  value={weeklySlotForm.max_capacity}
                  onChange={handleWeeklySlotInputChange}
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    height: "32px",
                    borderRadius: "2px",
                    border: "1px solid",
                    borderColor: "secondary.border",
                    padding: "5px 12px",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    color: "black",
                  }}
                />
                {weeklySlotErrors.max_capacity && (
                  <Typography
                    sx={{ color: "red", fontSize: "12px", lineHeight: "18px" }}
                  >
                    {weeklySlotErrors.max_capacity}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "22px",
                  }}
                >
                  Cutoff Minutes Before
                </Typography>
                <InputBase
                  type="number"
                  name="cutoff_minutes_before"
                  value={weeklySlotForm.cutoff_minutes_before}
                  onChange={handleWeeklySlotInputChange}
                  sx={{
                    backgroundColor: "white",
                    width: "100%",
                    height: "32px",
                    borderRadius: "2px",
                    border: "1px solid",
                    borderColor: "secondary.border",
                    padding: "5px 12px",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    color: "black",
                  }}
                />
                {weeklySlotErrors.cutoff_minutes_before && (
                  <Typography
                    sx={{ color: "red", fontSize: "12px", lineHeight: "18px" }}
                  >
                    {weeklySlotErrors.cutoff_minutes_before}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box sx={{ display: "flex", gap: "24px", mt: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Switch
                  checked={!!weeklySlotForm.is_active}
                  onChange={handleWeeklySlotToggleChange("is_active")}
                />
                <Typography sx={{ fontSize: "14px" }}>Active</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Switch
                  checked={!!weeklySlotForm.is_holiday}
                  onChange={handleWeeklySlotToggleChange("is_holiday")}
                />
                <Typography sx={{ fontSize: "14px" }}>Holiday</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Switch
                  checked={!!weeklySlotForm.future_booking_allowed }
                  onChange={handleWeeklySlotToggleChange("future_booking_allowed")}
                />
                <Typography sx={{ fontSize: "14px" }}>Future Booking Allowed</Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              backgroundColor: "#EEEEEE",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Box sx={{ padding: "12px 24px", display: "flex", gap: "20px" }}>
              <Button
                variant="outlined"
                sx={{
                  textTransform: "none",
                  color: "black",
                  backgroundColor: "white",
                  height: "32px",
                  width: "67px",
                }}
                onClick={handleCloseWeeklySlotModal}
              >
                cancel
              </Button>
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  height: "32px",
                  width: "80px",
                  position: "relative",
                }}
                onClick={handleSaveWeeklySlot}
                disabled={weeklySlotsLoading}
              >
                {weeklySlotsLoading ? (
                  <CircularProgress size={20} sx={{ color: "#ED1E79" }} />
                ) : (
                  "Save"
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}


